import { useEffect, useState } from 'react';
import { createTemplate, editTemplate, getTemplate, getTemplates, removeTemplate } from '../../../api/resultsTemplates';
import { HandleApiError } from '../../../components/Notifications/APIErrorHandler';

export const useResultsTemplates = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalSize, setTotalSize] = useState(0);
    const [query, setQuery] = useState({
        pagination: {
            page: 1,
            sizePerPage: 10,
            totalSize: 0
        }
    });
    const [reload, setReload] = useState(false);

    useEffect(() => {
        let isSubscribed = true
        const fetchData = async () => {
            try {
                setReload(false);
                setIsLoading(true);
                const res = await getTemplates();

                if (isSubscribed) {
                    //setTotalSize(res.data);
                    setData(res.data);
                    setIsLoading(false);
                }

            } catch (error) {
                HandleApiError(error);
                setIsLoading(false);
                setTotalSize(0);
                setData([]);
            }
        }

        fetchData();

        return () => isSubscribed = false;
    }, [query, reload]);

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        var newQuery = JSON.parse(JSON.stringify(query));

        switch (type) {
            case 'pagination': {
                newQuery.pagination.page = page;
                newQuery.pagination.sizePerPage = sizePerPage;
                setQuery(newQuery);
                break;
            }
            case 'sort': {
                newQuery.sort.sortField = sortField;
                newQuery.sort.sortOrder = sortOrder;
                setQuery(newQuery);
                break;
            }
        }
    }

    return [data, query, totalSize, isLoading, handleTableChange, setReload];
}

export const useResultsTemplate = (id) => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);

    useEffect(() => {
        let isSubscribed = true
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const res = await getTemplate(id);

                if (isSubscribed) {
                    setData(res.data);
                    setIsLoading(false);
                }

            } catch (error) {
                HandleApiError(error);
                setIsLoading(false);
                setData(null);
            }
        }
        if (id)
            fetchData();

        return () => isSubscribed = false;
    }, [id]);

    const create = (data) => {
        return createTemplate(data);
    }

    const update = (id, data) => {
        return editTemplate(id, data);
    }

    const remove = (id) => {
        return removeTemplate(id);
    }

    return [data, isLoading, create, update, remove];
}